export default __webpack_public_path__ + "static/media/341.c3694d82.png";